import React from 'react';
import DOMPurify from 'dompurify';

function DisplayQuillContent({ content }) {
  // Sanitize the HTML content
  const sanitizedContent = DOMPurify.sanitize(content);

  return (
    <span dangerouslySetInnerHTML={{ __html: sanitizedContent }} style={{
      p: {
        margin: 0,
        padding: 0,
      },
    }}
    />
  );
}

export default DisplayQuillContent;
